import { isRetailerEligibleForOwF } from "@faire/retailer-visitor-shared/views/SignUp/_utils/signupUtilities";
import { useSignUpOwfStore } from "@faire/retailer-visitor-shared/views/SignUp/open-with-faire/shared/SignUpOwfStore";
import { useMutation as useSignUpTermsScreenMutation } from "@faire/web-api--source/endpoints/www/api/retailer/retailerToken/sign-up-terms-screen/post-hooks";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { ISignUpTermsScreenResponse } from "@faire/web-api--source/indigofair/data/ISignUpTermsScreenResponse";
import { useCallback } from "react";

export const useSetRealTimeOwFStatus = () => {
  const setShouldShowRealTimeOwF = useSignUpOwfStore(
    (state) => state.setShouldShowRealTimeOwF
  );
  const { mutateAsync: getSignUpTermsStatus } = useSignUpTermsScreenMutation({
    onError: () => setShouldShowRealTimeOwF(false),

    onSuccess: (data: ISignUpTermsScreenResponse) => {
      setShouldShowRealTimeOwF(data.should_show_realtime_experience ?? false);
    },
  });

  return useCallback(
    async (retailer: IRetailer | undefined) => {
      if (!retailer) {
        return;
      }

      const isOpenWithFaireEligible = isRetailerEligibleForOwF(retailer);
      if (!isOpenWithFaireEligible) {
        return;
      }

      await getSignUpTermsStatus([retailer?.token ?? "", {}]);
    },
    [getSignUpTermsStatus]
  );
};
